export const mergeCategoryIdsIntoQueryParams = (
    query: Record<string, any>,
    categoryIds: Array<string | number>
): Record<string, any> => {
    if (categoryIds.length === 0) {
        return query;
    }

    const existingCategoryIds = String(query.category_id ?? '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
    const mergedCategoryIds = [...new Set([...existingCategoryIds, ...categoryIds.map(String)])];

    return {
        ...query,
        category_id: mergedCategoryIds.join(','),
    };
};
